<template>
<div>
  <div class="map" id="map"></div>
</div>
</template>

<script>

import L from 'leaflet';
import Vue from 'vue';
import { mapState } from 'vuex';
// TODO: Update paths
import mapMarker from '@/assets/img/map_marker.svg';
import mapPhaseMarker from '@/assets/img/map_phase_marker.svg';
import dashboardPopup from '@/views/Dashboard/dashboardPopup.vue';

export default {
  data() {
    return {
      map: '',
      id: '2',
      projectLayer: '',
      markers: {},
      phase: '',      
      polylineData: []
    };
  },
  mounted() {
    this.initMap();

    this.$root.$on('hoverProjectCard', (id) => {
      this.id = id;
      const layerId = this.projectLayer.getLayerId(this.markers[this.id]);
      const getProjectLayer = this.projectLayer.getLayer(layerId);
      if (this.map.getZoom() > 15) {
        this.map.setZoom(15);
      }
      this.map.setView(getProjectLayer.getLatLng());
      getProjectLayer.openPopup();
    });

    this.$root.$on('drawPolyline', (id) => {
      this.drawPhaseLayer(id);
    });

    this.$root.$on('zoomToPhase', (id) => {
      this.zoomToPolyline(id);
    });

    this.$root.$on('destroyPolyline', (id) => {
      this.destroyPolyline(id);
    });    

    this.initProjectLayers();
  },
  computed: {
    ...mapState([
      'projects',
    ]),
  },
  watch: {
    projects() {
      this.initProjectLayers();
    },
  },
  methods: {
    initMap() {
      // Initialize map
      this.map = L.map('map', {
        zoomControl: false,
        attributionControl: false,
      }).setView([12.971599, 77.594566], 3);

      // Add zoom control to topright corner
      L.control.zoom({
        position: 'topright',
      }).addTo(this.map);

      // Create a tilelayer
      this.tileLayer = L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoic293amFueWFlbm5hbSIsImEiOiJjamk1dnRta3Uwb2FyM3FtcmRkM2h0Z2gwIn0.2Fuzb-3EnJBBgzCcWHwKfw', {
       attribution: '© <a href="https://www.mapbox.com/feedback/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        },
        {
          maxZoom: 20,
          subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        }
      );

      // Add the created tilelayer to map
      this.tileLayer.addTo(this.map);
    },

    initProjectLayers() {
      // Create Project Icon
      const sdIcon = L.icon({
        iconUrl: mapMarker,
        iconSize: [38, 95],
        popupAnchor: [-3, -35],
        iconAnchor: [19, 70],
      });

      // Create a feature Group for project level markers
      this.projectLayer = L.featureGroup();

      Array.from(this.projects).forEach((project) => {
        const id = project.project_id;
        this.markers[id] = L.marker([
          parseFloat(project.latitude),
          parseFloat(project.longitude),
        ], {
          icon: sdIcon,
        })  
          .bindPopup(this.dashboardPopupDesign({project}), {'className': 'sd-map-dashboardPopup'}) 
          .addTo(this.map);        
        this.projectLayer.addLayer(this.markers[id]);
      });
      if ( this.projectLayer.getBounds().isValid() ) {
        this.map.fitBounds(this.projectLayer.getBounds(), {
          padding: [80, 80],
        });
      }
    },

    dashboardPopupDesign(data) {  
      let name = data.project.name;
      let id = data.project.project_id;      
      const Popup = Vue.extend(dashboardPopup);      
      const dashboardPopupComponent = new Popup({
        propsData: {
          name,
          id,         
        },
        parent: this,
      });      
      return dashboardPopupComponent.$mount().$el;
    },

    drawPhaseLayer(projectId) {
      // create a polyline from an array of LatLng points
      // TODO: Add css class instead of styling here
      const sdIcon = L.icon({
        iconUrl: mapPhaseMarker,
        iconSize: [25.5, 35],
        popupAnchor: [-3, -76],
        iconAnchor: [-1, 35],
      });
      let polyline = null;
      let phaseMarkerLayer = null;
      const phaseMarkers = [];

      Array.from(this.projects).forEach((project) => {
        if (project.project_id === projectId) {          
            const latlngs = [];            
            const polylineLayer = [];
            Array.from(project.subsections).forEach((subsection) => {
              const subLatlngs = [];              
              // TODO: Add css class instead of styling here
              let color = '#7ed321';

              if (subsection.status === 'In progress') {
                color = '#f6c253';
              } else if (subsection.status === 'Yet to begin') {
                color = '';
              }
              if (subsection.data.length) {
                subsection.data[0].position.forEach((latlng, index) => {
                  // Add phase marker to map
                  if (index === 2) { // Math.round(subsections.length / 2)
                  // console.log(parseFloat(latlng.split(',')[0]), parseFloat(latlng.split(',')[1]));
                  const marker =  L.marker(latlng, {
                    icon: sdIcon,
                  });
                  phaseMarkers.push(marker);   
                 }
                subLatlngs.push(latlng);
                });
            
                phaseMarkerLayer=L.layerGroup(phaseMarkers).addTo(this.map);
                polyline = L.polyline(subLatlngs, {
                  color,
                  weight: 3,
                });
                polylineLayer.push(polyline);
                polyline.addTo(this.map);
                latlngs.push([...subLatlngs]);
              }
            });             
            // eslint-disable-next-line
            const subsectionPointerPolyline= L.polyline(latlngs, {
              color: 'black',
              weight: 10,
              opacity: 0.5,
            });
            project.subsectionPointer = subsectionPointerPolyline.addTo(this.map);
            project.subsectionPointer.bringToBack();
            this.polylineData.push({
              projectId: projectId,
              polyline: polylineLayer,
              subsectionPointerPolyline: subsectionPointerPolyline, 
              phaseMarkers: phaseMarkers,
              phaseMarkerLayer: phaseMarkerLayer,
            });        
            // zoom the map to the polyline
            this.map.fitBounds(project.subsectionPointer.getBounds(), {
            padding: [80, 80],
          });
        }
      });
    },

    zoomToPolyline(projectId) {      
      Array.from(this.projects).forEach((project) => {
        if (project.project_id === projectId) {
          this.map.fitBounds(project.subsectionPointer.getBounds(), {            
            padding: [80, 80],
          });
        }
      });
    },

    destroyPolyline(projectId) {      
      Array.from(this.polylineData).forEach((project) => {
        if(projectId === project.projectId) {        
         Array.from(project.polyline).forEach((polyline) => {
           this.map.removeLayer(polyline);
         });         
         this.map.removeLayer(project.subsectionPointerPolyline);
         project.phaseMarkerLayer.clearLayers();         
        }
      });
    },

  },
};
</script>

<style lang="scss">

// TODO: Update Path
@import "../../../node_modules/leaflet/dist/leaflet.css";

.map {
 height: 100vh;
 width: auto;
 margin-right: -13px;
}

.sd-map-dashboardPopup {
  -webkit-border-radius: 1 rem!important;
  -moz-border-radius: 1 rem!important;
  border-radius: 1 rem !important;
  padding:0.1rem;    
}
</style>
